import { render, staticRenderFns } from "./MonthlyIncomeTemplate.vue?vue&type=template&id=5f577a88&scoped=true&"
import script from "./MonthlyIncomeTemplate.vue?vue&type=script&lang=js&"
export * from "./MonthlyIncomeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyIncomeTemplate.vue?vue&type=style&index=0&id=5f577a88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f577a88",
  null
  
)

export default component.exports